import { Badge, Text } from '@cinesend/ui-kit'
import { AirplaneTilt } from '@phosphor-icons/react'
import CycleIsValidatingTag from '../../../components/cycles_table/validation_status_tag'
import { convertToLongDate } from '../../../helpers/convert_date'
import DashboardWidget from '../widget'

const DetailRow = ({ label, value }) => (
  <p className='m-0 flex min-w-0 flex-wrap gap-x-1 text-[length:var(--cs-text-sm-font-size)] leading-[var(--cs-text-sm-line-height)]'>
    <Text as='span' variant='sm-medium'>
      {label}
    </Text>
    <Text as='span' variant='sm' tone='secondary' className='min-w-0'>
      {value || '—'}
    </Text>
  </p>
)

const DetailsWidget = ({ airline, cycle, ...widgetProps }) => {
  const start = convertToLongDate(cycle?.start_date)
  const end = convertToLongDate(cycle?.end_date)
  const window = [start, end].filter(Boolean).join(' - ')

  return (
    <DashboardWidget title='Details' {...widgetProps}>
      <div className='relative flex h-full flex-col gap-4'>
        <div className='flex items-start justify-between gap-3'>
          <div className='flex min-w-0 items-center gap-3'>
            <AirplaneTilt size={28} weight='regular' aria-hidden='true' className='shrink-0' />
            <Text as='p' variant='md-medium' className='min-w-0 truncate'>
              {airline?.name}
            </Text>
          </div>
          <div className='flex shrink-0 flex-wrap items-center justify-end gap-2'>
            {cycle?.status_label ? <Badge tone='info'>{cycle.status_label}</Badge> : null}
            <CycleIsValidatingTag is_validating={cycle?.is_validating} />
          </div>
        </div>
        <div className='flex min-h-0 flex-1 flex-col justify-center'>
          <div className='flex flex-col divide-y divide-[color:var(--cs-color-border-subtle)]'>
            <div className='py-2 first:pt-0 last:pb-0'>
              <DetailRow label='Cycle Name:' value={cycle?.name} />
            </div>
            <div className='py-2 first:pt-0 last:pb-0'>
              <DetailRow label='Cycle Description:' value={cycle?.description} />
            </div>
            <div className='py-2 first:pt-0 last:pb-0'>
              <DetailRow label='Cycle Window:' value={window} />
            </div>
          </div>
        </div>
      </div>
    </DashboardWidget>
  )
}

export default DetailsWidget
